import { DataCache, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { VesselServiceOverrideResponse } from 'data/models/VesselServiceOverrideResponse';

export class VesselServiceOverrideCache extends DataCache {
    VesselServiceOverrideResponses = PCCollection(VesselServiceOverrideResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.VesselServiceOverrideResponses, data.Vessels, o => o.Vessel, null);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselserviceoverride/cache.ts